import BaseModel from '../../base';
import CertificateProfile from '../../certificate-profile';

import constants from './constants';
import { REQUEST_STATUS } from '../constants';
import glossary, { REQUEST_STATUS_DATA } from './glossary';

export default class AssociationUser extends BaseModel {
  constructor(item = {}, url) {
    super(item, url);

    this.full_name = item.full_name;
    this.event_association_status = item.event_association_status || item.status || REQUEST_STATUS.new;
    this.username = item.username;

    this.card_number = item.card_number;
    this.legal_member_full_name = item.legal_member_full_name;
    this.profile = item.profile ? new CertificateProfile(item.profile) : undefined;
    this.clubs = item.clubs || [];
    this.representative_office = item.representative_office;
    this.request_at = item.request_at;
    this.reject_at = item.reject_at;
    this.accept_at = item.accept_at;
  }

  get statusData() {
    const { event_association_status } = this;
    const data = REQUEST_STATUS_DATA[event_association_status];
    return {
      ...data,
      isNew: event_association_status === REQUEST_STATUS.new,
      isAccepted: event_association_status === REQUEST_STATUS.accepted,
      isRejected: event_association_status === REQUEST_STATUS.rejected,
    };
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }
}
